var d = new Date()
export const ReferralColDef = [
    {       Header:  'תאריך',  
            accessor: 'family_referral_date', 
            type: "text",
            editable: true,
            default: d.getDate()+"/"+ (d.getMonth()+1) +"/"+ d.getFullYear()
    },
    {       Header:  'שם משפחה',  
            accessor: 'family_referral_family_name', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'שם האשה',  
            accessor: 'family_referral_woman_firstname', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'שם הגבר',  
            accessor: 'family_referral_man_firstname', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'קוד הפניה',  
            accessor: 'family_referral_code', 
            type: "text",
            editable: false,
            default: 999999 
    },
    {       Header:  'קוד משפחה',  
            accessor: 'family_referral_family_code', 
            type: "text",
            editable: false,
            default: 0 
    },
    {       Header:  'מלווה',  
            accessor: 'family_referral_team', 
            type: "text",
            editable: true,
            default: "מיטל" 
    },
    {       Header:  'סטטוס הפניה',  
            accessor: 'family_referral_status', 
            type: "select",
            editable: true,
            default: "התקבלה פניה. טרם התבצע ברור",
            options: ["התקבלה פניה. טרם התבצע בירור","ברור עם המשפחה","ברור עם גורם מפנה","קבלה לאינטייק", "עברה לאינטייק", 
            "סיום. אין התאמה", "סיום. יש פוטנציאל", "סיום. המשפחה ויתרה","לא מוגדר"]
    },
    {       Header:  'נייד אשה',  
            accessor: 'family_referral_cell_woman', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'נייד גבר',  
            accessor: 'family_referral_cell_man', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'גורם מפנה',  
            accessor: 'family_referral_initiator', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'גיל אשה',  
            accessor: 'family_referral_age_woman', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'גיל גבר',  
            accessor: 'family_referral_age_man', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'סטטוס אישי',  
            accessor: 'family_referral_merita_status', 
            type: "select",
            editable: true,
            default: "",
            options: ['נשואים', 'גרושים', 'חד-הורית', 'פרודים', 'אלמן/ה', 'ידועים בציבור', 'חיים יחד'] // meritalStatus
    },
    {       Header:  'מספר ילדים',  
            accessor: 'family_referral_num_kids', 
            type: "text",
            editable: true,
            default: ""
    },
    {       Header:  'מקום עבודה אשה',  
            accessor: 'family_refferal_woman_workplace', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'מקום עבודה גבר',  
            accessor: 'family_refferal_man_workplace', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'חובות משפחה',  
            accessor: 'family_referral_debts', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'לקוחה של הרווחה',  
            accessor: 'family_referral_os_client', 
            type: "select",
            editable: true,           
            default: "",
            options: [ 'כן', 'לא', 'היינו בעבר'] 
    },
    {       Header:  'השתתפה בתכנית שיפור',  
            accessor: 'family_referral_prev_plan', 
            type: "checkbox",
            editable: true,
            default: "" 
    },
    {       Header:  'באיזה תכנית השתתפה',  
            accessor: 'family_referral_prev_plan_name', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'האם התבצעה שיחת טלפון',  
            accessor: 'family_referral_phone_call', 
            type: "checkbox",
            editable: true,
            default: "" 
    },
    {       Header:  'האם נקבע אינטייק',  
            accessor: 'family_referral_intake_set', 
            type: "checkbox",
            editable: true,
            default: "" 
    },
    {       Header:  'תאריך אינטייק',  
            accessor: 'family_referral_intake_date', 
            type: "text",
            editable: true,
            default: "" 
    },
    {       Header:  'סיבה מרכזית',  
            labelOnly: true,
            accessor: 'family_referral_reason', 
            type: "text",
            editable: false,
            options: ['קשיים בהתנהלות כלכלית שוטפת', 'חובות כבדים', 'הכנסות נמוכות', 
                        'אבטלה או תעסוקה לא איכותית', 'מצב משפחתי רעוע', 'קשיים של ילדים'],
            default: "" 
    },
    {       Header:  'קשיים בהתנהלות כלכלית שוטפת שיפור',  
            accessor: 'family_referral_r1', 
            type: "select",
            options:["לא", "כן"], //noYes
            editable: true,
            default: "" 
    },
    {       Header:  'חובות כבדים',  
            accessor: 'family_referral_r2', 
            type: "select",
            options:["לא", "כן"],
            editable: true,
            default: "" 
    },
    {       Header:  'הכנסות נמוכות',  
            accessor: 'family_referral_r3', 
            type: "select",
            options:["לא", "כן"],
            editable: true,
            default: "" 
    },
    {       Header:  'אבטלה או תעסוקה לא איכותית',  
            accessor: 'family_referral_r4', 
            type: "select",
            options:["לא", "כן"],
            editable: true,
            default: "" 
    },
    {       Header:  'מצב משפחתי רעוע',  
            accessor: 'family_referral_r5', 
            type: "select",
            options:["לא", "כן"],
            editable: true,
            default: "" 
    },
    {       Header:  'קשיים של ילדים',  
            accessor: 'family_referral_r6', 
            type: "select",
            options:["לא", "כן"],
            editable: true,
            default: "" 
    },
    {       Header:  'החלטת מנהלת',  
            accessor: 'family_referral_mgr_decision', 
            type: "select",
            options:["קבלה לאינטייק", "דחיה", "המשך בירור", "העברה לתכנית אחרת","אחר"], // newTBD
            editable: true,
            default: "המשך בירור" 
    },
    {       Header:  'החלטת משפחה',  
            accessor: 'family_referral_family_decision', 
            type: "select",
            options:["המשך לאינטייק", "ויתור", "המשך בירור", "אחר"], // newTBD
            editable: true,
            default: "המשך בירור" 
    },
    {       Header:  'הסבר החלטת משפחה',  
            accessor: 'family_referral_family_explain', 
            type: "textarea",
            editable: true,
            default: "" 
    },
    {       Header:  'הסבר החלטת מנהלת',
            accessor: 'family_referral_mgr_explain', 
            type: "textarea",
            editable: true,
            default: "" 
    }
]